import clsx from 'clsx';

import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';

import { DocumentPreview } from 'src/components/documentPreview';
import { MediaInfoProps } from 'src/components/documentPreview/types';

import { ImageContainer, IconContainer } from '../styles';
import Icon from '../../Icon';
import { PostType } from '../../../hook/usePosts';
import { ImagePreview } from './ImagePreview';
import { VideoPreview } from './VideoPreview';

type PropsMedia = {
  media: string;
  mediaType: number;
  removeMedia: () => void;
  mediaInfo?: MediaInfoProps;
  isMediaComment?: boolean;
};

const PreviewMedia = ({
  media,
  mediaType,
  removeMedia,
  isMediaComment = false,
  mediaInfo
}: PropsMedia) => {
  switch (mediaType) {
    case PostType.DOCUMENT:
      return (
        <DocumentPreview
          isMediaComment={isMediaComment}
          removeMedia={removeMedia}
          mediaInfo={mediaInfo}
        />
      );

    default:
      return (
        <ImageContainer
          className={clsx('_position-relative', {
            '_position-relative _ml-4': isMediaComment,
            '_text-center _w-full _h-full _mb-5': !isMediaComment
          })}
          isMediaComment={isMediaComment}
        >
          <IconContainer
            onClick={removeMedia}
            className="_position-absolute _bg-white _p-3 _rounded _d-flex _align-items-center _justify-content-center _text-gray-500"
            isMediaComment={isMediaComment}
          >
            <Icon icon={faTrash} />
          </IconContainer>
          {mediaType === PostType.IMAGE && (
            <ImagePreview media={media} isMediaComment={isMediaComment} />
          )}
          {mediaType === PostType.VIDEO && <VideoPreview media={media} />}
        </ImageContainer>
      );
  }
};

export default PreviewMedia;
